import React from 'react';
import { colors, spacing, typography } from '../tokens/index.js';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const getVariantStyles = (variant) => {
    const variants = {
      primary: {
        backgroundColor: colors.text.primary,
        color: colors.text.inverse,
        border: 'none',
        '&:hover': {
          backgroundColor: colors.primary[200],
        }
      },
      secondary: {
        backgroundColor: colors.background.secondary,
        color: colors.text.primary,
        border: `1px solid ${colors.border.default}`,
        '&:hover': {
          backgroundColor: colors.primary[500],
        }
      },
      outline: {
        backgroundColor: 'transparent',
        color: colors.text.primary,
        border: `1px solid ${colors.border.light}`,
        '&:hover': {
          backgroundColor: colors.alpha.light12,
        }
      },
      ghost: {
        backgroundColor: 'transparent',
        color: colors.text.primary,
        border: 'none',
        '&:hover': {
          backgroundColor: colors.alpha.light12,
        }
      }
    };
    return variants[variant] || variants.primary;
  };

  const getSizeStyles = (size) => {
    const sizes = {
      small: {
        padding: '0.5rem 1rem',
        fontSize: typography.fontSize.sm,
        height: '2rem',
      },
      medium: {
        padding: spacing.component.buttonPadding,
        fontSize: typography.fontSize.base,
        height: spacing.component.buttonHeight,
      },
      large: {
        padding: '0.75rem 2rem',
        fontSize: typography.fontSize.lg,
        height: '3rem',
      }
    };
    return sizes[size] || sizes.medium;
  };

  const variantStyles = getVariantStyles(variant);
  const sizeStyles = getSizeStyles(size);

  const buttonStyles = {
    ...variantStyles,
    ...sizeStyles,
    fontFamily: typography.fontFamily.primary,
    fontWeight: typography.fontWeight.normal,
    borderRadius: spacing.borderRadius.full,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textDecoration: 'none',
    transition: 'all 0.15s ease-in-out',
    userSelect: 'none',
    outline: 'none',
    '&:focus': {
      boxShadow: `0 0 0 2px ${colors.alpha.light24}`,
    }
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`ds-button ${className}`}
      style={buttonStyles}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
